
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabs() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Cab',
    heading: 'AB Ghule Cabs: Pune to Shirdi Cab',
    headingDescription: 'AB Ghule Cabs offers reliable and comfortable Pune to Shirdi cab services, ensuring your journey is smooth, safe, and enjoyable. Whether you are traveling for a religious visit, a family trip, or a group outing, we provide well-maintained vehicles with experienced drivers to make your trip to Shirdi stress-free and comfortable. Our affordable cab services are perfect for both locals and tourists planning to visit the famous Sai Baba temple and other attractions in Shirdi. Pune is approximately 185 km from Shirdi.',

    top: 'Top Places to Visit in Shirdi with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Sai Baba Temple",
          description: "The Sai Baba Temple in Shirdi is the most famous and revered landmark in the town, attracting millions of devotees each year. Dedicated to Sai Baba, a spiritual leader who is believed to have performed miracles and imparted spiritual wisdom, the temple offers a serene and peaceful atmosphere for prayer, reflection, and spiritual connection. The temple’s sanctum houses the idol of Sai Baba, and it is one of the most important pilgrimage sites for devotees of the saint."
        },
        {
          title: "Dwarkamai Masjid",
          description: "Located close to the Sai Baba Temple, Dwarkamai Masjid is a significant place of worship and spiritual importance. This is where Sai Baba spent much of his life and performed many of his miracles. The masjid is considered sacred and is frequently visited by devotees seeking blessings. The structure of Dwarkamai Masjid is simple, yet it holds a profound place in the hearts of Sai Baba’s followers, offering a tranquil space for prayer and devotion."
        },
        {
          title: "Chavadi",
          description: "Chavadi is another important site in Shirdi, where Sai Baba spent alternate nights. The place holds great religious significance, as it was the location where Sai Baba performed several rituals and where his followers gathered to receive his blessings. The simple yet peaceful environment of Chavadi continues to draw devotees who seek to connect with Sai Baba’s spirit and teachings."
        },
        {
          title: "Shani Shingnapur",
          description: "Located about 70 kilometers from Shirdi, Shani Shingnapur is a renowned temple dedicated to Lord Shani, the god of justice. This temple is unique because it does not have any doors or locks, and it is believed that Lord Shani protects the village and its inhabitants from evil. The village itself is known for its absence of thefts, as it is believed that Lord Shani watches over the people and keeps them safe. A visit to Shani Shingnapur offers spiritual significance and a sense of divine protection."
        },
        {
          title: "Saibaba's Samadhi Mandir",
          description: "The Saibaba's Samadhi Mandir is the place where Sai Baba’s mortal remains are entombed. The temple offers a peaceful and contemplative environment for devotees to meditate, pray, and pay respects to the saint. It is one of the most sacred places in Shirdi and holds immense spiritual importance. The temple is visited by thousands of devotees who come to offer their prayers and seek Sai Baba’s blessings."
        },
        {
          title: "Lendi Baug",
          description: "Lendi Baug is a beautiful garden located near the Sai Baba Temple, dedicated to the saint’s memory. It holds historical significance, as Sai Baba used to spend time here, offering a place of reflection and spiritual calm. The garden houses a small shrine with a sacred neem tree that continues to be preserved and revered by visitors. Lendi Baug is a tranquil spot for those looking to connect with the divine presence of Sai Baba and experience peace in nature."
        },
        {
          title: "Khandoba Temple",
          description: "Situated on the outskirts of Shirdi, Khandoba Temple is dedicated to Lord Khandoba, a popular deity in Maharashtra. The temple is an important pilgrimage site for many devotees, particularly those visiting Shirdi for the first time. It is often one of the first stops for pilgrims before heading to the Sai Baba Temple. The temple's simple yet spiritual atmosphere makes it a significant location for religious practices and devotion."
        },
        {
          title: "Museum at Shirdi",
          description: "The Shirdi Museum provides a fascinating insight into the life, teachings, and legacy of Sai Baba. The museum houses personal items that belonged to Sai Baba, including clothes, religious artifacts, and more. It is an educational stop for those interested in learning about Sai Baba’s life and his impact on his followers. The museum offers visitors an opportunity to reflect on the saint’s teachings and connect with his spiritual legacy."
        },
        {
          title: "Gurusthan",
          description: "Gurusthan is the place where Sai Baba was first seen by his devotees when he arrived in Shirdi. This sacred spot holds immense spiritual importance, as it marks the beginning of Sai Baba’s divine presence in the town. Devotees often visit Gurusthan to offer prayers and seek blessings, as it is believed to be a place where spiritual energy is abundant. The location continues to be a vital pilgrimage site for those seeking to connect with Sai Baba’s spirit."
        },
        {
          title: "Nanda Deep",
          description: "Nanda Deep is an eternal flame that burns near the Sai Baba Temple. The flame symbolizes the divine spiritual presence of Sai Baba and serves as a reminder of his eternal guidance and blessings. Nanda Deep is an essential part of the Sai Baba Temple complex and holds deep spiritual significance. Devotees often visit the flame to offer their prayers and connect with Sai Baba’s enduring legacy."
        }
      ],


   services: [
    {
      "name": "Pune to Shirdi Cab",
      description: "Travel comfortably and conveniently with AB Ghule Cabs for your trip from Pune to Shirdi. We offer a wide range of vehicles to choose from, including sedans, SUVs, and luxury cars, ensuring a pleasant and smooth journey to the sacred town of Shirdi."
    },
    {
      "name": "Pune to Shirdi Taxi",
      description: "Book a reliable taxi service from Pune to Shirdi with AB Ghule Cabs. Our experienced drivers ensure you reach Shirdi in comfort, providing timely pick-up and drop-off at the most competitive fares."
    },
    {
      "name": "Pune to Shirdi Cab Package",
      description: "Make your trip more enjoyable with AB Ghule Cabs' exclusive Pune to Shirdi cab packages. These packages are designed for your convenience and comfort, covering round trips and multiple-day stays, with special attention to your needs."
    },
    {
      "name": "Pune to Shirdi Cab Charges",
      description: "Get affordable and transparent pricing for your trip from Pune to Shirdi with AB Ghule Cabs. We offer competitive cab charges with no hidden fees, ensuring you have a cost-effective and enjoyable journey."
    },
    {
      "name": "Pune to Shirdi Cab Fare",
      description: "The fare for a cab from Pune to Shirdi depends on the type of vehicle and travel duration. AB Ghule Cabs provides an affordable fare structure that is designed to suit your budget, so you can travel stress-free and within your means."
    },
    {
      "name": "Pune to Shirdi Cab One Way",
      description: "If you're looking for a one-way trip, AB Ghule Cabs offers affordable one-way cab services from Pune to Shirdi. Our one-way fare ensures that you don't have to pay for the return journey, making it an economical option."
    },
    {
      "name": "Pune to Shirdi Taxi Fare",
      description: "AB Ghule Cabs offers transparent and competitive pricing for a taxi ride from Pune to Shirdi. Our fare includes all taxes, tolls, and other charges, so you can be assured there are no hidden costs."
    },
    {
      "name": "Shirdi to Pune Cab",
      description: "Booking a return cab from Shirdi to Pune? AB Ghule Cabs provides reliable and cost-effective services for your return journey from Shirdi to Pune. Our experienced drivers and comfortable cars ensure you travel with ease."
    },
    {
      "name": "Pune to Shirdi Cab Service",
      description: "AB Ghule Cabs offers professional and reliable taxi services for your journey from Pune to Shirdi. Whether you are traveling for pilgrimage, leisure, or business, we ensure a smooth and comfortable ride."
    },
    {
      "name": "Pune to Shirdi Cab Booking Service",
      description: "Booking a cab from Pune to Shirdi has never been easier. With AB Ghule Cabs' user-friendly online booking service, you can reserve your ride in just a few clicks, ensuring a hassle-free trip to Shirdi."
    },
    {
      "name": "Pune to Shirdi Taxi Drop",
      description: "If you need a taxi for a one-way drop from Pune to Shirdi, AB Ghule Cabs offers convenient drop services. You can trust our punctual drivers to take you to your destination on time, providing a safe and comfortable ride."
    },
    {
      "name": "Pune Airport to Shirdi Cab",
      description: "For passengers arriving at Pune Airport, AB Ghule Cabs provides reliable taxi services to Shirdi. Our airport-to-Shirdi transfer ensures that you reach your destination on time, with comfortable and well-maintained vehicles."
    },
    {
      "name": "Pune to Shirdi Car Rental",
      description: "Looking for a car rental for your trip from Pune to Shirdi? AB Ghule Cabs offers a range of rental options to suit your needs, whether you’re traveling alone, with family, or in a group. Choose from a variety of cars and enjoy the freedom to travel at your own pace."
    },
    {
      "name": "Pune to Shirdi Cab Booking",
      description: "Booking a cab for your Pune to Shirdi trip is easy with AB Ghule Cabs. Our booking system is quick, convenient, and secure, so you can reserve your ride online and relax knowing your trip is in safe hands."
    },
    {
      "name": "Pune to Shirdi Cab Price",
      description: "The price of your cab from Pune to Shirdi will depend on your vehicle choice, travel time, and distance. AB Ghule Cabs provides upfront pricing with no hidden charges, so you’ll know exactly what you’re paying for."
    },
    {
      "name": "Pune Airport to Shirdi Cab Price",
      description: "AB Ghule Cabs offers a competitive price for airport transfers from Pune to Shirdi. Our rates are reasonable and transparent, providing you with a reliable and cost-effective taxi service directly from Pune Airport to Shirdi."
    },
    {
      "name": "Cab for Shirdi from Pune",
      description: "Book a comfortable and affordable cab for your trip to Shirdi with AB Ghule Cabs. Whether it's for a short visit or a longer stay, our cabs are designed to ensure you have a safe and enjoyable ride."
    },
    {
      "name": "Pune Airport to Shirdi Taxi Fare",
      description: "AB Ghule Cabs offers reasonable taxi fares for transfers from Pune Airport to Shirdi. Our taxi service ensures timely pickups and a comfortable journey, so you can relax and enjoy your ride."
    },
    {
      "name": "Pune Airport to Shirdi Taxi Drop",
      description: "Need a taxi drop from Pune Airport to Shirdi? With AB Ghule Cabs, you can easily book a taxi for your journey from the airport to Shirdi. Our professional drivers will ensure a smooth ride, and we provide timely drop-offs so you won’t miss your destination."
    },
    {
      "name": "Pune to Shirdi Cab Cost",
      description: "The cost of your Pune to Shirdi cab ride is competitive and affordable. AB Ghule Cabs offers budget-friendly options, and we ensure no hidden fees or additional charges, so you can travel with peace of mind."
    },
    {
      "name": "Pune to Shirdi Cab Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Shirdi Cab. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],




tableData: [
  ["Pune to Shirdi Cab", "-Pune to Shirdi Taxi"],
  ["Pune to Shirdi Cab Package", "-Pune to Shirdi Cab Charges"],
  ["Pune to Shirdi Cab fare", "-Pune to Shirdi cab one way"],
  ["Pune to Shirdi taxi fare", "-Shirdi to Pune Cab"],
  ["Pune to Shirdi Cab Service", "-Pune to Shirdi cab booking service"],
  ["Pune to Shirdi taxi drop", "-Pune airport to Shirdi cab"],
  ["Pune to Shirdi car rental", "-Pune to Shirdi cab booking"],
  ["Pune to Shirdi cab price", "-Pune airport to Shirdi cab price"],
  ["Cab for Shirdi from Pune", "-Pune airport to Shirdi taxi fare"],
  ["Pune airport to Shirdi taxi drop", "-Pune to Shirdi cab cost"]
],

whychoose: [
  {
    WhyChooseheading: "Reliable and Timely Service",
    WhyChoosedescription: "At AB Ghule Cabs, we understand the importance of punctuality, especially when traveling to a religious destination like Shirdi. Our drivers are always on time, ensuring that you can begin your spiritual journey from Pune to Shirdi without any delays."
  },
  {
    WhyChooseheading: "Comfortable and Safe Ride",
    WhyChoosedescription: "Our fleet consists of well-maintained vehicles, ensuring that you have a comfortable and safe ride to Shirdi. With air-conditioning, ample space, and a smooth ride, you can relax and enjoy the trip, whether you're traveling alone, with family, or in a group."
  },
  {
    WhyChooseheading: "Experienced and Professional Drivers",
    WhyChoosedescription: "Our drivers are not only skilled and professional but also knowledgeable about the Pune to Shirdi route. They are committed to ensuring your journey is smooth, safe, and free of stress, guiding you through the best routes and providing an excellent experience."
  },
  {
    WhyChooseheading: "Affordable and Transparent Pricing",
    WhyChoosedescription: "AB Ghule Cabs offers affordable pricing for your Pune to Shirdi trip, with no hidden charges. Our fare structure is transparent, giving you the best value for your money, whether you’re traveling solo or with a group."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "Our vehicles are regularly serviced and inspected to ensure they are in perfect condition for the journey. You can trust that your ride to Shirdi will be comfortable and free of any technical issues."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "We operate around the clock, so you can book your Pune to Shirdi cab at any time, be it early morning or late at night. Our customer service team is always available to assist you with bookings or queries."
  },
  {
    WhyChooseheading: "Hassle-Free Booking",
    WhyChoosedescription: "Booking a cab with AB Ghule Cabs is simple and fast. You can make a reservation through our website, mobile app, or by calling our customer service team. We ensure an easy and hassle-free booking experience."
  },
  {
    WhyChooseheading: "Specialized for Religious Tours",
    WhyChoosedescription: "We specialize in offering religious tours to destinations like Shirdi. Whether you're going for a quick visit or a longer stay, we ensure that your journey is smooth and stress-free, so you can focus on your spiritual experience."
  }
]

  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Shirdi with AB Ghule Cabs?',
      answer: 'You can book a cab easily through our website, mobile app, or by calling our customer service team. We provide multiple booking options for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced for Pune to Shirdi trips?',
      answer: 'Yes, all our drivers are highly experienced and well-versed with the Pune to Shirdi route. They prioritize your safety and comfort throughout the journey.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking from Pune to Shirdi?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, to suit your travel needs, whether you\'re traveling alone, with family, or in a group.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride from Pune to Shirdi?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our mobile app, ensuring a convenient and flexible payment process.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Shirdi?',
      answer: 'Yes, you can book a round trip for your journey. Just provide your return details during booking, and we will arrange the entire trip for you.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Any additional charges for waiting time or detours will be communicated to you upfront. We maintain transparency in pricing, so you won’t have any surprises.',
    },
    {
      id: 'FAQ7',
      question: 'Can I hire a cab for a religious tour in Shirdi?',
      answer: 'Yes, we specialize in providing religious tours to Shirdi. Our drivers will ensure you visit key spots in Shirdi, including the Sai Baba Temple, with a comfortable and hassle-free journey.',
    },
    {
      id: 'FAQ8',
      question: 'What is the luggage allowance for my trip to Shirdi?',
      answer: 'Our vehicles have ample space for standard luggage. If you have special luggage needs or additional baggage, please let us know during booking, and we’ll accommodate your requirements.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for corporate travel to Shirdi?',
      answer: 'Yes, we provide corporate travel solutions to Shirdi, including rides for group trips, conferences, and religious visits. Contact us for customized packages for your business.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best choice for Pune to Shirdi travel?',
      answer: 'AB Ghule Cabs stands out due to its reliability, affordable pricing, experienced drivers, well-maintained vehicles, and transparent pricing. We ensure a safe, smooth, and comfortable journey to Shirdi.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Sanjay Patil',
      feedback: 'I booked a cab from Pune to Shirdi with AB Ghule Cabs for a spiritual trip, and I’m thoroughly impressed. The driver was experienced, and the journey was smooth and comfortable. I reached Shirdi on time and was able to enjoy my visit without any stress. I highly recommend AB Ghule Cabs for anyone traveling to Shirdi!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Aishwarya Deshmukh',
      feedback: 'AB Ghule Cabs made our pilgrimage to Shirdi a memorable experience. The driver was very polite, and the car was clean and comfortable. It was a smooth ride from Pune to Shirdi, and we didn’t face any issues during the journey. I would definitely choose AB Ghule Cabs again for future trips.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Shirdi Cab | Affordable & Reliable</title>
  <meta name="description" content="Book Pune to Shirdi cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Cab Package, Pune to Shirdi Cab Charges, Pune to Shirdi Cab fare, Pune to Shirdi cab one way, Pune to Shirdi taxi fare, Shirdi to Pune Cab, Pune to Shirdi Cab Service, Pune to Shirdi cab booking service, Pune to Shirdi taxi drop, Pune airport to Shirdi cab, Pune to Shirdi car rental, Pune to Shirdi cab booking, Pune to Shirdi cab price, Pune airport to Shirdi cab price, Cab for Shirdi from Pune, Pune airport to Shirdi taxi fare, Pune airport to Shirdi taxi drop, Pune to Shirdi cab cost" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Shirdi Cab | Affordable & Reliable" />
  <meta property="og:description" content="Book Pune to Shirdi cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-shirdi-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-shirdi-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Shirdi Cab",
        description: "Book Pune to Shirdi cabs with AB Ghule Cabs. Affordable and reliable taxi services for one-way, round trips, and airport drop. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-shirdi-cab",
        "logo": "https://abghulecabs.com/images/pune-to-shirdi-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-shirdi-cabs.jpg",
        "priceRange": "₹2500 - ₹4500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-shirdi-cab",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1100"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh Kumar"
            },
            "datePublished": "2024-12-20",
            "reviewBody": "Fantastic service for our trip to Shirdi! The driver was professional, and the cab was comfortable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali Deshmukh"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Affordable and prompt service. Had a great time traveling to Shirdi with AB Ghule Cabs."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Shirdi",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.1802",
            "longitude": "74.5246"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-shirdi-cab"
        },
        "keywords": "Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Cab Package, Pune to Shirdi Cab Charges, Pune to Shirdi Cab fare, Pune to Shirdi cab one way, Pune to Shirdi taxi fare, Shirdi to Pune Cab, Pune to Shirdi Cab Service, Pune to Shirdi cab booking service, Pune to Shirdi taxi drop, Pune airport to Shirdi cab, Pune to Shirdi car rental, Pune to Shirdi cab booking, Pune to Shirdi cab price, Pune airport to Shirdi cab price, Cab for Shirdi from Pune, Pune airport to Shirdi taxi fare, Pune airport to Shirdi taxi drop, Pune to Shirdi cab cost"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoshirdicabs;